import { render } from "./edit-quotations.vue?vue&type=template&id=ad9d5706"
import script from "./edit-quotations.vue?vue&type=script&lang=js"
export * from "./edit-quotations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__